import { render, staticRenderFns } from "./index.vue?vue&type=template&id=793005f6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793005f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('793005f6')) {
      api.createRecord('793005f6', component.options)
    } else {
      api.reload('793005f6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=793005f6&scoped=true", function () {
      api.rerender('793005f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/setup/type/index.vue"
export default component.exports